import React from 'react';
import { Tooltip, Divider } from 'antd';
import { renderIconDownload } from '../helpers';
import {OVERFLOW_MESSAGE} from './BlockConstants'

const DownloadBlock = ({ pos, report, download }) => {
  report.url = null;
  let { Icon} = renderIconDownload(report);
  const title = OVERFLOW_MESSAGE;
  return (    
    <>
        {pos !== 0 ? <Divider type='vertical' /> : null}
        <div aria-disabled >
            <Tooltip title={title}>
              {Icon}
            </Tooltip>
        </div>
    </>
  );
};

export default DownloadBlock;
